import React from 'react';

import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import PDPSellingAttributesUI from './PDPSellingAttributesUI';

const PDPSellingAttributesInner = () => {
  const {
    loading: basicDetailsLoading,
    data: basicDetails,
  } = usePDPBasicDetails();

  if (basicDetailsLoading) {
    return <PDPSellingAttributesUI loading />;
  }

  const {
    custom_properties: { selling_attributes } = {},
    type: { name } = {},
  } = basicDetails ?? {};

  if (!selling_attributes?.length) {
    return null;
  }

  return (
    <PDPSellingAttributesUI
      attributes={selling_attributes || []}
      productType={name}
    />
  );
};

const PDPSellingAttributes = props => (
  <SuspenseWithLoader fallback={<PDPSellingAttributesUI loading />}>
    <PDPSellingAttributesInner {...props} />
  </SuspenseWithLoader>
);

export default PDPSellingAttributes;
